'use strict';

/* globals define, config, ajaxify */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/fill-blanks-game/game', [
	config.relative_path + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js',
	'fillBlanksGameViewer',
], function (vue, fillBlanksGameViewer) {
	var	Game = {};

	Game.init = function () {
		fillBlanksGameViewer.init(ajaxify.data.game, ajaxify.data.translations);
	};

	return Game;
});
